import React, { useState } from 'react'
import PropTypes from 'prop-types'

import clsx from 'clsx'
import { Redirect } from 'react-router-dom'

import { makeStyles, useTheme } from '@material-ui/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import { Permitted } from 'components/Permissions'
import { Sidebar, Topbar, Footer, ScreenLoading } from './components'
import useAuth from 'hooks/useAuth'
import SnackbarProvider from 'providers/SnackbarProvider'
import ConfirmDialogProvider from 'providers/ConfirmDialogProvider'
import styles from './styles'

const useStyles = makeStyles(styles)

const Main = ({ permission, admin, children }) => {
  const classes = useStyles()
  const theme = useTheme()
  const auth = useAuth()
  const [openSidebar, setOpenSidebar] = useState(false)
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true,
  })
  const shouldOpenSidebar = isDesktop ? true : openSidebar
  const redirectRoute = auth.permissions
    ? auth.checkMainRoute(auth.permissions)
    : null

  return (
    <ScreenLoading loaded={!auth.isLoading && auth.loaded}>
      <SnackbarProvider>
        <ConfirmDialogProvider>
          <Permitted
            tag={permission}
            admin={admin}
            fallback={redirectRoute ? <Redirect to={redirectRoute} /> : null}
          >
            <div
              className={clsx({
                [classes.root]: true,
                [classes.shiftContent]: isDesktop,
              })}
            >
              <Topbar onSidebarOpen={() => setOpenSidebar(true)} />
              <Sidebar
                onClose={() => setOpenSidebar(false)}
                open={shouldOpenSidebar}
                variant={isDesktop ? 'persistent' : 'temporary'}
              />
              <main className={classes.content}>
                {children}
                <Footer />
              </main>
            </div>
          </Permitted>
        </ConfirmDialogProvider>
      </SnackbarProvider>
    </ScreenLoading>
  )
}

Main.propTypes = {
  children: PropTypes.node,
}

export default Main
